module.exports = __webpack_public_path__ + "static/media/AvenirLTPro-Medium.719d04c9.woff";